module.exports = "<template bindable=\"item\">\n  <div class=\"listSelector_title\">\n    ${item.listSelectorDisplay.label}\n  </div>\n</template>\n";